<div class="ai-chat-panel" role="dialog" aria-modal="true"
     aria-owns="ai-chat-avatar-toggle"
     [attr.aria-label]="resourceStrings['Aon.AI.Avatar.AonAiChat']"
     aria-describedby="ai-chat-panel-subtitle">

  <div class="backdrop" (click)="close()" aria-hidden="true"></div>
  <div #aiChatMessageAnnouncer id="ai-chat-message-announcer" aria-live="polite" aria-atomic="true" class="sr-only"></div>

  <div class="ai-container">
    <div class="content">
      <div class="welcome">
        <h1 class="welcome-title">{{ welcomeTitle }}</h1>
        <p id="ai-chat-panel-subtitle" class="welcome-subtitle lg">{{ resourceStrings['Aon.AiChat.Panel.WelcomeSubTitle'] }}</p>
      </div>

      <div class="date">
        <p>{{ currentDate | date:'MMMM d, yyyy' }}</p>
      </div>

      @for (message of messages; track $index; let last = $last) {
      <app-chat-tile [chatMessage]="message"
                     [isNiceChatEnabled]="isNiceChatEnabled"
                     [autoFocus]="last && !message.thinkingIndicator && !message.isRequestHasError && message.type === 'receiver'"
                     (launchLiveChat)="openLiveChat()"
                     (navigateToHelp)="navigateToHelp()"
                     (showLiveChatPrompt)="onShowLiveChatPrompt($event)">
      </app-chat-tile>
      }
    </div>

    <form [formGroup]="chatForm" class="input-container" autocomplete="off"
          [ngStyle]="{ background: backgroundColor }"
          (ngSubmit)="onSubmit()">
      <input formControlName="queryInput" type="text" id="askAnyThing" appCursorToEnd
             [placeholder]="resourceStrings['Aon.AI.Widget.AskAnything']"
             [attr.aria-required]="isRequiredField(chatForm, 'queryInput')"          
             (focus)="onInputFocus()" (blur)="onInputBlur()" />
      <i role="button"
         class="fal fa-paper-plane-top send-btn"
         tabindex="0"
         [attr.aria-disabled]="disableSubmitButton ? 'true' : null"
       
         (click)="onSendAttempt()"
         (keydown.enter)="onSendAttempt()"
         (keydown.space)="onSendAttempt(); $event.preventDefault()">
         <span class="sr-only">{{ resourceStrings['Aon.AI.Widget.AccessibleSendMessage'] }}</span></i>
    </form>

    <div class="disclaimer-bar" [ngStyle]="{ background: backgroundColor }">
      <span #disclaimer class="disclaimer-text"
            [ngbPopover]="disclaimerText"
            [disablePopover]="!hasEllipsis"
            [triggers]="'mouseenter:mouseleave'"
            placement="top">
        {{ disclaimerText }}
      </span>
      <a #termsLink routerLink="/home/terms-conditions"
         class="ai-terms-link"
         (click)="close()"
         [innerHTML]="resourceStrings['Aon.AI.Chat.Panel.DisclaimerAONAILink']">
      </a>
    </div>
  </div>
</div>
